import { ca } from '@cian/analytics';
import { EPageBlock, INewPromoBlockPageExtra } from '../../../types/analytics';
import { INewbuildingPromo } from '../../../types/promosPage';
import { IPage } from '../../../types/redux';

type TAction = 'show_sopr' | 'Click';

interface ITrackFreshPromos {
  action: TAction;
  position: number;
  promo: INewbuildingPromo;
  page: IPage;
}

export function trackFreshPromos({ action, position, promo, page }: ITrackFreshPromos) {
  const pageExtra: INewPromoBlockPageExtra = {
    block: EPageBlock.NewPromo,
    newbuilding_id: promo.newbuildingId,
    promo_id: promo.providerPromoId,
    provider_type: promo.providerType,
    position,
  };

  return ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action,
    label: 'Block',
    page: {
      ...page,
      extra: pageExtra,
    },
  });
}
